import React from "react";
import "./card-style.scss";
import c from "classnames";

const Card = ({ className, children }) => {
  return <div className={c("card", className)}>{children}</div>;
};

export default Card;
